import Head from 'next/head'
import { useRouter } from 'next/router'
import { useState, useEffect } from 'react'
import { Card, Col, Image, Row, Form, InputGroup, FormControl, Button, Container, Modal } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faSlidersH, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import JobFilters from './JobFilters'
import Job from '../Job'
import styles from '../../styles/Company.module.scss'
import browseStyles from '../../styles/BrowseJobs.module.scss'
import jobFiltersStyles from '../../styles/JobFilters.module.scss'
import techTalentStyles from '../../styles/TechTalent.module.scss'
import { formatHTML } from '../../utils/html-utils'

const Event104Company: React.FC = (props: any) => {
	const router = useRouter()

	const [tempKeyword, setTempKeyword] = useState<string>('')
	const [filters, setFilters] = useState(props.filters || {
		jobCategories: [],
		jobOccupations: [],
		jobLevels: [],
		jobTypes: [],
		keyword: '',
		page: 1,
		minSalary: null,
		maxSalary: null
	})
	const [showJobFilterModal, setShowJobFilterModal] = useState(false)

	useEffect(() => {
		const query = router.query
		const jobCategories = query.c ? (query.c as string).split(',').filter((el: string) => el !== '') : []
		const jobOccupations = query.o ? (query.o as string).split(',').filter((el: string) => el !== '') : []
		// const jobLevels = query.level ? (query.level as string).split(',').filter((el: string) => el !== '') : []
		const jobTypes = query.type ? (query.type as string).split(',').filter((el: string) => el !== '') : []
		const keyword = query.q ? query.q as string : ''
		const page = query.page ? parseInt(query.page as string) : 1
		const minSalary = query.minSalary ? parseInt(query.minSalary as string) : null
		const maxSalary = query.maxSalary ? parseInt(query.maxSalary as string) : null

		setFilters({
			jobCategories,
			jobOccupations,
			// jobLevels,
			jobTypes,
			keyword,
			page,
			minSalary,
			maxSalary
		})
		setTempKeyword(keyword)
	}, [router.query])

	const buildCompanyUrl = (filters: any) => {
		// Build URL with filters for company page
		const url = new URL(window.location.href)
		if (filters.jobCategories && filters.jobCategories.length > 0) {
			url.searchParams.set('c', filters.jobCategories.join(','))
		} else {
			url.searchParams.delete('c')
		}
		if (filters.jobOccupations && filters.jobOccupations.length > 0) {
			url.searchParams.set('o', filters.jobOccupations.join(','))
		} else {
			url.searchParams.delete('o')
		}
		if (filters.jobTypes && filters.jobTypes.length > 0) {
			url.searchParams.set('type', filters.jobTypes.join(','))
		} else {
			url.searchParams.delete('type')
		}
		// if (filters.jobLevels && filters.jobLevels.length > 0) {
		// 	url.searchParams.set('level', filters.jobLevels.join(','))
		// } else {
		// 	url.searchParams.delete('level')
		// }
		if (filters.keyword) {
			url.searchParams.set('q', filters.keyword)
		} else {
			url.searchParams.delete('q')
		}
		if (filters.minSalary !== null && filters.minSalary !== undefined) {
			url.searchParams.set('minSalary', filters.minSalary.toString())
		} else {
			url.searchParams.delete('minSalary')
		}
		if (filters.maxSalary !== null && filters.maxSalary !== undefined) {
			url.searchParams.set('maxSalary', filters.maxSalary.toString())
		} else {
			url.searchParams.delete('maxSalary')
		}
		if (filters.page && filters.page > 1) {
			url.searchParams.set('page', filters.page.toString())
		} else {
			url.searchParams.delete('page')
		}
		return url.pathname + url.search
	}

	const handleInputChange = (event: any): any => {
		const target = event.target
		const value = target.value
		setTempKeyword(value)
	}

	const handleSubmit = (event: any): any => {
		setFilters({
			...filters,
			keyword: tempKeyword,
		})
		router.push(buildCompanyUrl({ ...filters, keyword: tempKeyword }))
		event.preventDefault()
	}

	const getPaginationLink = (page: string): string => {
		return buildCompanyUrl({ ...filters, page: parseInt(page) })
	}
	return (
		<div className={techTalentStyles.mainContainer}>
			<Head>
				<title>{props.company.name} | Findjobs</title>
			</Head>
			<Container>
				{/* header */}
				<Row className="mb-4">
					<Col className="text-center">
						<div className={styles.imageContainer}>
							<Image
								className={styles.companyAvatar}
								src={props.company.avatar}
								alt=""
							/>
						</div>
						<h2 className="mb-0 mt-1">{props.company.name}</h2>
					</Col>
				</Row>
				{/* search bar */}
				<Form onSubmit={handleSubmit} className="mb-4">
					<Row className="justify-content-center g-1">
						<Col md={10} xs={12}>
							<InputGroup>
								<InputGroup.Text className={browseStyles.inputGroupText}>
									<FontAwesomeIcon icon={faSearch} />
								</InputGroup.Text>
								<FormControl
									type="text"
									size="lg"
									name="keyword"
									value={tempKeyword}
									placeholder="Search for jobs..."
									onChange={handleInputChange}
									className={`${browseStyles.input} ${techTalentStyles.color}`}
									style={{ borderTopRightRadius: '15px', borderBottomRightRadius: '15px' }}
								/>
							</InputGroup>
						</Col>
						<Col md={1} xs={4} className="d-none d-md-block">
							<Button
								variant="primary"
								type="submit"
								size="lg"
								style={{ backgroundColor: '#6E368D', borderColor: '#6E368D', color: 'white' }}
							>
									Search
							</Button>
						</Col>
					</Row>
					<Row className="justify-content-center mt-2 d-md-none">
						<Col xs={12}>
							<Button
								variant="primary"
								type="submit"
								size="lg"
								className="w-100"
								style={{ backgroundColor: '#6E368D', borderColor: '#6E368D', color: 'white' }}
							>
								Search
							</Button>
						</Col>
					</Row>
				</Form>
				{/* Mobile Filter Button */}
				<div className="d-block d-md-none mb-4">
					<Button
						type='button'
						className={`${techTalentStyles.primaryBtn} text-white px-4 py-2`}
						size='lg'
						onClick={() => { setShowJobFilterModal(true) }}
					>
						<FontAwesomeIcon icon={faSlidersH} className="me-2" />
						Filter
					</Button>
				</div>
				<Row>
					{/* Filters sidebar */}
					<Col md={4} className="d-none d-md-block">
						{/* About section */}
						{props.company && (
							<div className="mb-4">
								<Card className={jobFiltersStyles.filterCard}>
									<Card.Body className={jobFiltersStyles.filterBody}>
										<h4>About Company</h4>
										{props.company.description && <pre>{formatHTML(props.company.description)}</pre>}
										{props.company.video !== null && props.company.video !== '' && (
											<div className="video-responsive">
												<iframe
													width="560"
													height="315"
													src={props.company.video}
													title="YouTube video player"
													frameBorder="0"
													allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
													allowFullScreen
												/>
											</div>
										)}
									</Card.Body>
								</Card>
							</div>
						)}
						<JobFilters
							filters={filters}
							eventId={props.eventId || props.companyId.toString()}
							urlBuilder={(id, filters) => buildCompanyUrl(filters)}
							categoryJobCounts={props.categoryJobCounts}
							totalJobs={props.jobAggregate?.aggregate?.count || 0}
						/>
					</Col>
					{/* Jobs section */}
					<Col md={8}>
						{props.jobs.length > 0 ? (
							props.jobs.map((job: any, index: number) => {
								return (
									<div key={index} className="mb-3">
										<Job
											job={job}
											showAvatar={false}
											query={
												props.eventId !== null
													? `event=${props.eventId as string}`
													: ''
											}
											isCompanyDetail={true}
											eventId={props.eventId}
										/>
									</div>
								)
							})
						) : (
							<div className="text-center">
								<p>No jobs found. Try adjusting your search or filters.</p>
							</div>
						)}
					</Col>
				</Row>
				{/* Mobile About Company */}
				{props.company && (
					<div className="d-block d-md-none mb-4">
						<Card className={jobFiltersStyles.filterCard}>
							<Card.Body className={jobFiltersStyles.filterBody}>
								<h4>About Company</h4>
								{props.company.description && <pre>{formatHTML(props.company.description)}</pre>}
								{props.company.video !== null && props.company.video !== '' && (
									<div className="video-responsive">
										<iframe
											width="560"
											height="315"
											src={props.company.video}
											title="YouTube video player"
											frameBorder="0"
											allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
											allowFullScreen
										/>
									</div>
								)}
							</Card.Body>
						</Card>
					</div>
				)}
				{props.jobs.length > 0 && props.jobAggregate.aggregate.count > 10 ? (
					<div className={`${styles.paginationContainer} mt-4`}>
						<nav aria-label="Page navigation example">
							<ul className="pagination justify-content-center pagination-md">
								<li
									className={
										props.pagination.prev ? 'page-item' : 'page-item disabled'
									}
								>
									<a
										className="page-link"
										href={getPaginationLink(
											(parseInt(props.page) - 1).toString(),
										)}
										aria-disabled="true"
									>
										<FontAwesomeIcon icon={faChevronLeft} width="12px" />
									</a>
								</li>
								{props.pagination.pagi.map((pagi, index) => {
									return (
										<li
											key={index}
											className={
												pagi === 'dotted'
													? 'page-item disabled'
													: pagi === parseInt(props.page)
														? 'page-item active'
														: 'page-item'
											}
										>
											<a
												className="page-link"
												href={getPaginationLink(pagi.toString())}
											>
												{pagi === 'dotted' ? '...' : pagi}
											</a>
										</li>
									)
								})}
								<li
									className={
										props.pagination.next ? 'page-item' : 'page-item disabled'
									}
								>
									<a
										className="page-link"
										href={getPaginationLink(
											(parseInt(props.page) + 1).toString(),
										)}
									>
										<FontAwesomeIcon icon={faChevronRight} width="12px" />
									</a>
								</li>
							</ul>
						</nav>
					</div>
				) : (
					<br />
				)}
			</Container>
			{/* Job Filter Modal for Mobile */}
			<Modal show={showJobFilterModal} onHide={() => { setShowJobFilterModal(false) }} className='bottom-modal' size='lg'>
				<Modal.Body>
					<div>
						<div style={{ maxHeight: '60vh', overflow: 'auto' }}>
							<JobFilters
								filters={filters}
								eventId={props.eventId || props.companyId.toString()}
								urlBuilder={(id, filters) => buildCompanyUrl(filters)}
								categoryJobCounts={props.categoryJobCounts}
							/>
						</div>
						<br />
						<div className="text-center">
							<Button className={`text-white w-100 ${techTalentStyles.primaryBtn}`} onClick={() => { setShowJobFilterModal(false) }}>
								Close
							</Button>
						</div>
					</div>
					<br />
				</Modal.Body>
			</Modal>
		</div>
	)
}

export default Event104Company